/* RESPONSIBLE TEAM: team-standalone */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type ReactTeammateAppIslandService from 'embercom/services/react-teammate-app-island';
import type Store from '@ember-data/store';

export default class InternalAgentSidebarService extends Service {
  @service declare reactTeammateAppIsland: ReactTeammateAppIslandService;
  @service declare store: Store;

  @tracked isOpen = false;
  @tracked lastChatId: string | null = null;

  private unsubscribers: Array<() => void> = [];

  init() {
    super.init();
    this.unsubscribers.push(
      this.reactTeammateAppIsland.subscribeToTeammateAppEvent('internal-agent:close-sidebar', () =>
        this.close(),
      ),
      this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
        'internal-agent:chat-id-changed',
        (data: Record<string, unknown>) => {
          this.lastChatId = data['chatId'] as string;
        },
      ),
      this.reactTeammateAppIsland.subscribeToTeammateAppEvent(
        'internal-agent:proposal-applied',
        () => {
          // Refresh guidelines from the server so the Ember page reflects proposal changes
          this.store.findAll('ai-agent/guidelines');
        },
      ),
    );
  }

  willDestroy() {
    super.willDestroy();
    this.unsubscribers.forEach((unsub) => unsub());
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }
}

declare module '@ember/service' {
  interface Registry {
    'internal-agent-sidebar': InternalAgentSidebarService;
    internalAgentSidebar: InternalAgentSidebarService;
  }
}
